import { APP_LOCALSTORAGE_PREFIX_KEY } from '@/configs/local-storage.config';
import {
  deleteLocalStorageData,
  getLocalStorageData,
  saveLocalStorageData,
} from '@/utils/local-storage';

export const authLocalStorage = {
  ACCESS_TOKEN: `${APP_LOCALSTORAGE_PREFIX_KEY}access_token`,
  REFRESH_TOKEN: `${APP_LOCALSTORAGE_PREFIX_KEY}refresh_token`,
  USER: `${APP_LOCALSTORAGE_PREFIX_KEY}user`,

  getAccessToken: () => {
    return getLocalStorageData(authLocalStorage.ACCESS_TOKEN);
  },

  getRefreshToken: () => {
    return getLocalStorageData(authLocalStorage.REFRESH_TOKEN);
  },

  getUser: () => {
    return getLocalStorageData(authLocalStorage.USER);
  },

  setAccessToken: (token: string) => {
    saveLocalStorageData(authLocalStorage.ACCESS_TOKEN, token);
  },

  setRefreshToken: (token: string) => {
    saveLocalStorageData(authLocalStorage.REFRESH_TOKEN, token);
  },

  setUser: (user: unknown) => {
    saveLocalStorageData(authLocalStorage.USER, user);
  },

  clearAuthTokens: () => {
    deleteLocalStorageData(authLocalStorage.ACCESS_TOKEN);
    deleteLocalStorageData(authLocalStorage.REFRESH_TOKEN);
    deleteLocalStorageData(authLocalStorage.USER);
  },
};
